/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Percent_OffInputs */

const en_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% OFF`)
};

const es_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% DE DESCUENTO`)
};

const fr_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% DE RÉDUCTION`)
};

const de_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% RABATT`)
};

const ja_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% OFF`)
};

const zh_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% 优惠`)
};

const ar_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% خصم`)
};

const id_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DISKON %`)
};

const it_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% SCONTO`)
};

const ru_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% СКИДКА`)
};

const pt_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% OFF`)
};

const ko_percent_off = /** @type {(inputs: Percent_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% 할인`)
};

/**
* | output |
* | --- |
* | "% OFF" |
*
* @param {Percent_OffInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const percent_off = /** @type {((inputs?: Percent_OffInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Percent_OffInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_percent_off(inputs)
	if (locale === "es") return es_percent_off(inputs)
	if (locale === "fr") return fr_percent_off(inputs)
	if (locale === "de") return de_percent_off(inputs)
	if (locale === "ja") return ja_percent_off(inputs)
	if (locale === "zh") return zh_percent_off(inputs)
	if (locale === "ar") return ar_percent_off(inputs)
	if (locale === "id") return id_percent_off(inputs)
	if (locale === "it") return it_percent_off(inputs)
	if (locale === "ru") return ru_percent_off(inputs)
	if (locale === "pt") return pt_percent_off(inputs)
	return ko_percent_off(inputs)
});